import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handleSystemLogin } from "@/redux/auth/sessions/actions";

const SystemLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const nonce = params.get("nonce");
    const next = params.get("next") || "/apps";
    if (nonce) {
      dispatch<any>(handleSystemLogin(nonce, navigate, next));
    } else {
      navigate("/login", { replace: true });
    }
  }, [location.search]);

  return null;
};

export default SystemLogin;


